<template>
    <v-container class="settings">
        <v-layout row wrap>
            <v-flex xs12 lg8 offset-lg2>
                <v-card>
                    <v-card-title class="pb-1">
                        <h3 class="headline mb-0">Persönliches</h3>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap justify-center>
                            
                            <v-flex xs12>
                                <small>Name</small>
                                <v-input messages="Anrede, Vor- und Nachname" prepend-icon="person">
                                    {{ user.salutation ? `${user.salutation} ${user.title ? user.title+' ' : ''}${user.forename} ${user.surname}` : `` }}
                                    <template slot="append">
                                        <v-bottom-sheet v-model="show_form_name" lazy inset>
                                            <template v-slot:activator>
                                                <v-btn icon>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card class="pa-3" tile>
                                                <v-form ref="form_name" lazy-validation @submit.prevent="submit('form_name')">
                                                    <v-layout row wrap justify-center>
                                                        <v-flex xs6 md3 px-2>
                                                            <v-select 
                                                                ref="user.salutation" 
                                                                :items="['', 'Herr', 'Frau', 'Divers']" 
                                                                v-model="user.salutation" 
                                                                :rules="[rules.required]"
                                                                name="salutation" 
                                                                label="Anrede"
                                                                required
                                                            />
                                                        </v-flex>
                                                        <v-flex xs6 md3 px-2>
                                                            <v-select 
                                                                ref="user.title" 
                                                                :items="[{value:'', text:''},{value:'Dr.', text:'Doktor'},{value:'Prof.', text:'Professor'},{value:'Prof. Dr.', text:'Professor Doktor'}]" 
                                                                v-model="user.title" 
                                                                name="title" 
                                                                clearable
                                                                label="Titel"
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md3 px-2>
                                                            <v-text-field
                                                                ref="user.forename"
                                                                v-model="user.forename"
                                                                maxlength="20"
                                                                label="Vorname"
                                                                placeholder=""
                                                                clearable
                                                                autocomplete="given-name"
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md3 px-2>
                                                            <v-text-field
                                                                ref="user.surname"
                                                                v-model="user.surname"
                                                                maxlength="36"
                                                                :rules="[rules.required, () => !!user.surname && user.surname.length >= 3 || 'Der Nachname muss aus mindestens 3 Zeichen bestehen']"
                                                                label="Nachname *"
                                                                placeholder=""
                                                                clearable
                                                                autocomplete="family-name"
                                                                required
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-card-actions class="pa-0">
                                                        <v-btn flat color="secondary" @click="show_form_name = false">Abbrechen</v-btn>
                                                        <v-spacer />
                                                        <v-btn color="black" dark @click="submit('form_name')">Speichern</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-card>
                                        </v-bottom-sheet>
                                    </template>
                                </v-input>
                                <v-divider class="my-2"></v-divider>
                            </v-flex>

                            <v-flex xs12>
                                <small>Geburstag</small>
                                <v-input messages="Datum Ihrer Geburt" prepend-icon="cake">
                                    {{ user.birthday_date=='0000-00-00' || user.birthday_date==null ? '' : $moment(user.birthday_date).format('DD.MM.YYYY').toString() }}
                                    <template slot="append">
                                        <v-bottom-sheet v-model="show_form_bday" lazy inset>
                                            <template v-slot:activator>
                                                <v-btn icon>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card class="pa-3" tile>
                                                <v-form ref="form_bday" lazy-validation @submit.prevent="submit('form_bday')">
                                                    <v-layout row wrap justify-center>
                                                        <v-flex xs12>
                                                            <v-text-field
                                                                ref="user.birthday_date"
                                                                type="date"
                                                                v-model="user.birthday_date"
                                                                :rules="[rules.required, rules.adult]"
                                                                label="Geburstag *"
                                                                max="2002-04-01"
                                                                clearable
                                                                autocomplete="bday"
                                                                required
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-card-actions class="pa-0">
                                                        <v-btn flat color="secondary" @click="show_form_bday = false">Abbrechen</v-btn>
                                                        <v-spacer />
                                                        <v-btn color="black" dark @click="submit('form_bday')">Speichern</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-card>
                                        </v-bottom-sheet>
                                    </template>
                                </v-input>
                                <v-divider class="my-2"></v-divider>
                            </v-flex>

                            <v-flex xs12>
                                <small>Telefonnummer</small>
                                <v-input messages="Für eventuelle Rückfragen / Schadensbearbeitung vom Versicherer" prepend-icon="phone">
                                    {{ user.fon }}
                                    <template slot="append">
                                        <v-bottom-sheet v-model="show_form_tel" lazy inset>
                                            <template v-slot:activator>
                                                <v-btn icon>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card class="pa-3" tile>
                                                <v-form ref="form_tel" lazy-validation @submit.prevent="submit('form_tel')">
                                                    <v-layout row wrap justify-center>
                                                        <v-flex xs12>
                                                            <v-text-field
                                                                ref="user.fon"
                                                                type="tel"
                                                                v-model="user.fon"
                                                                label="Telefonnummer"
                                                                clearable
                                                                autocomplete="tel"
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-card-actions class="pa-0">
                                                        <v-btn flat color="secondary" @click="show_form_tel = false">Abbrechen</v-btn>
                                                        <v-spacer />
                                                        <v-btn color="black" dark @click="submit('form_tel')">Speichern</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-card>
                                        </v-bottom-sheet>
                                    </template>
                                </v-input>
                                <v-divider class="my-2"></v-divider>
                            </v-flex>

                            <v-flex xs12>
                                <small>E-Mail-Adresse</small>
                                <v-input messages="Ihre E-Mail-Adresse, über die Sie Nachrichten Ihrer Vertragspartner erhalten" prepend-icon="mail_outline">
                                    {{ $store.state.auth.fb.email }}
                                    <template slot="append">
                                        <v-btn to="/accountsettings" icon>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                    </template>
                                </v-input>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs12 lg8 offset-lg2>
                <v-card class="mt-4">
                    <v-card-title class="pb-1">
                        <h3 class="headline mb-0">Unternehmensdaten</h3>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap justify-center>
                            <v-flex xs12>
                                <small>Unternehmensname und Rechtsform</small>
                                <v-input messages="Ihr eingetragener Name beim Gewerbeamt, bei Freiberufler: Vor- und Nachname" prepend-icon="domain">
                                    {{ user.company ? `${user.company} ${user.legal}` : `` }}
                                    <template slot="append">
                                        <v-bottom-sheet v-model="show_form_company" lazy inset>
                                            <template v-slot:activator>
                                                <v-btn icon>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card class="pa-3" tile>
                                                <v-form ref="form_company" lazy-validation @submit.prevent="submit('form_company')">
                                                    <v-layout row wrap justify-center>
                                                        <v-flex xs12 md6 pr-2>
                                                            <v-text-field
                                                                ref="user.company"
                                                                :rules="[rules.required]"
                                                                v-model="user.company"
                                                                name="company"
                                                                label="Unternehmensname *"
                                                                hint="exklusive der Firmierung"
                                                                maxlength="120"
                                                                clearable
                                                                autocomplete="organization"
                                                                required
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md6 pl-2>
                                                            <v-select
                                                                :items="legalforms"
                                                                item-text="text"
                                                                item-value="val"
                                                                label="Rechtsform *"
                                                                ref="user.legal"
                                                                :rules="[rules.required]"
                                                                v-model="user.legal"
                                                                name="legal"
                                                                clearable
                                                                required
                                                            ></v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-card-actions class="pa-0">
                                                        <v-btn flat color="secondary" @click="show_form_company = false">Abbrechen</v-btn>
                                                        <v-spacer />
                                                        <v-btn color="black" dark @click="submit('form_company')">Speichern</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-card>
                                        </v-bottom-sheet>
                                    </template>
                                </v-input>
                                <v-divider class="my-2"></v-divider>
                            </v-flex>

                            <v-flex xs12>
                                <small>Tätigkeit des Unternehmens</small>
                                <v-input messages="Welcher Tätigkeit (z.B. Webentwicklung) geht Ihr Unternehmen hauptsächlich nach?" prepend-icon="engineering">
                                    {{ user.business }}
                                    <template slot="append">
                                        <v-bottom-sheet v-model="show_form_business" lazy inset>
                                            <template v-slot:activator>
                                                <v-btn icon>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card class="pa-3" tile>
                                                <v-form ref="form_business" lazy-validation @submit.prevent="submit('form_business')">
                                                    <v-layout row wrap justify-center>
                                                        <v-text-field
                                                            ref="user.business"
                                                            type="text"
                                                            v-model="user.business"
                                                            label="Unternehmenstätigkeit"
                                                            maxlength="120"
                                                            clearable
                                                            autocomplete="off"
                                                        />
                                                    </v-layout>
                                                    <v-card-actions class="pa-0">
                                                        <v-btn flat color="secondary" @click="show_form_business = false">Abbrechen</v-btn>
                                                        <v-spacer />
                                                        <v-btn color="black" dark @click="submit('form_business')">Speichern</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-card>
                                        </v-bottom-sheet>
                                    </template>
                                </v-input>
                                <v-divider class="my-2"></v-divider>
                            </v-flex>
                            
                            <v-flex xs12>
                                <small>Gründungstag</small>
                                <v-input messages="Datum der Gewerbeanmeldung oder Beginn der Tätigkeit" prepend-icon="celebration">
                                    {{ user.founding_date=='0000-00-00' || user.founding_date==null ? '' : $moment(user.founding_date).format('DD.MM.YYYY').toString() }}
                                    <template slot="append">
                                        <v-bottom-sheet v-model="show_form_founding" lazy inset>
                                            <template v-slot:activator>
                                                <v-btn icon>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card class="pa-3" tile>
                                                <v-form ref="form_founding" lazy-validation @submit.prevent="submit('form_founding')">
                                                    <v-layout row wrap justify-center>
                                                        <v-text-field
                                                            ref="user.founding_date"
                                                            type="date"
                                                            v-model="user.founding_date"
                                                            label="Gründungsdatum *"
                                                            :max="$moment().format('YYYY-MM-DD').toString()"
                                                            :rules="[rules.required, () => !!user.founding_date && $moment().diff($moment(user.founding_date), 'days')>=0 || 'Das Gründungsdatum muss in der Vergangenheit liegen']"
                                                            clearable
                                                            required
                                                        />
                                                    </v-layout>
                                                    <v-card-actions class="pa-0">
                                                        <v-btn flat color="secondary" @click="show_form_founding = false">Abbrechen</v-btn>
                                                        <v-spacer />
                                                        <v-btn color="black" dark @click="submit('form_founding')">Speichern</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-card>
                                        </v-bottom-sheet>
                                    </template>
                                </v-input>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>


            <v-flex xs12 lg8 offset-lg2>
                <v-card class="mt-4">
                    <v-card-title class="pb-1">
                        <h3 class="headline mb-0">Bankdaten</h3>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap justify-center>
                            
                            <v-flex xs12>
                                <small>Persönliche Bankverbindung</small>
                                <v-input messages="Das zu belastene GiroKonto, welches bei privaten Verträgen zur Belastung verwendet werden soll / verwendet wird" prepend-icon="accessibility">
                                    <span v-html="(banks.private.bank_name ? banks.private.bank_name+'<br/>' : '') + (getCensoredIban(banks.private.iban)!='' ? getCensoredIban(banks.private.iban) : '')"></span>
                                    <template slot="append">
                                        <v-bottom-sheet v-model="show_form_privatebank" lazy inset>
                                            <template v-slot:activator>
                                                <v-btn icon>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card class="pa-3" tile>
                                                <v-form ref="form_privatebank" lazy-validation @submit.prevent="submit('form_privatebank')">
                                                    <v-layout row wrap justify-center>
                                                        <v-flex xs12 md4 pr-2>
                                                            <v-text-field
                                                                ref="banks.private.iban"
                                                                v-model="banks.private.iban"
                                                                :rules="[rules.required, rules.iban]"
                                                                label="IBAN *"
                                                                mask="AA## #### #### #### #### ##"
                                                                pattern="^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}$"
                                                                hint="Ohne Leer- oder Sonderzeichen eingeben"
                                                                maxlength="16"
                                                                clearable
                                                                required
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md4 px-2>
                                                            <v-text-field
                                                                ref="banks.private.bank_name"
                                                                v-model="banks.private.bank_name"
                                                                label="Name der Bank"
                                                                maxlength="36"
                                                                clearable
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md4 pl-2>
                                                            <v-text-field
                                                                ref="banks.private.owner_name"
                                                                v-model="banks.private.owner_name"
                                                                label="Inhaber"
                                                                hint="(falls abweichend)"
                                                                maxlength="60"
                                                                clearable
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-card-actions class="pa-0">
                                                        <v-btn flat color="secondary" @click="show_form_privatebank = false">Abbrechen</v-btn>
                                                        <v-spacer />
                                                        <v-btn color="black" dark @click="submit('form_privatebank')">Speichern</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-card>
                                        </v-bottom-sheet>
                                    </template>
                                </v-input>
                                <v-divider class="my-2"></v-divider>
                            </v-flex>

                            <v-flex xs12>
                                <small>Geschäftliche Bankverbindung</small>
                                <v-input messages="Das zu belastene Geschäftskonto, welches bei unternehmerischen Verträgen zur Belastung verwendet werden soll / verwendet wird" prepend-icon="business">
                                    <span v-html="(banks.company.bank_name ? banks.company.bank_name+'<br/>' : '') + (getCensoredIban(banks.company.iban)!='' ? getCensoredIban(banks.company.iban) : '')"></span>
                                    <template slot="append">
                                        <v-bottom-sheet v-model="show_form_companybank" lazy inset>
                                            <template v-slot:activator>
                                                <v-btn icon>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card class="pa-3" tile>
                                                <v-form ref="form_companybank" lazy-validation @submit.prevent="submit('form_companybank')">
                                                    <v-layout row wrap justify-center>
                                                        <v-flex xs12 md4 pr-2>
                                                            <v-text-field
                                                                ref="banks.company.iban"
                                                                v-model="banks.company.iban"
                                                                :rules="[rules.required, rules.iban]"
                                                                label="IBAN *"
                                                                mask="AA## #### #### #### #### ##"
                                                                pattern="^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}$"
                                                                hint="Ohne Leer- oder Sonderzeichen eingeben"
                                                                maxlength="16"
                                                                clearable
                                                                required
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md4 px-2>
                                                            <v-text-field
                                                                ref="banks.company.bank_name"
                                                                v-model="banks.company.bank_name"
                                                                label="Name der Bank"
                                                                maxlength="36"
                                                                clearable
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md4 pl-2>
                                                            <v-text-field
                                                                ref="banks.company.owner_name"
                                                                v-model="banks.company.owner_name"
                                                                label="Inhaber"
                                                                hint="(falls abweichend)"
                                                                maxlength="60"
                                                                clearable
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-card-actions class="pa-0">
                                                        <v-btn flat color="secondary" @click="show_form_companybank = false">Abbrechen</v-btn>
                                                        <v-spacer />
                                                        <v-btn color="black" dark @click="submit('form_companybank')">Speichern</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-card>
                                        </v-bottom-sheet>
                                    </template>
                                </v-input>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>


            <v-flex xs12 lg8 offset-lg2>
                <v-card class="mt-4">
                    <v-card-title class="pb-1">
                        <h3 class="headline mb-0">Anschriften / Niederlassungen</h3>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap justify-center>
                            <v-flex id="Geschäftsadresse" xs12>
                                <small>Geschäftsadresse</small>
                                <v-input messages="Ihre geschäftliche Anschrift" append-icon="edit" prepend-icon="edit_location">
                                    <span v-html="address_company.street ? `${address_company.street}${address_company.additional ? '<br/>'+address_company.additional : ''}<br/>${address_company.zipcode ? address_company.zipcode : ''} ${address_company.city ? address_company.city : ''}<br/>${getCountryFromCountrycode(address_company.countrycode)}` : ``"></span>
                                    <template slot="append">
                                        <v-bottom-sheet v-model="show_form_companyaddress" inset>
                                            <template v-slot:activator>
                                                <v-btn icon>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card class="pa-3" tile>
                                                <v-form ref="form_companyaddress" lazy-validation @submit.prevent="submit('form_companyaddress')">
                                                    <v-layout row wrap justify-center>
                                                        <v-flex xs12 md6 pr-2>
                                                            <v-text-field
                                                                v-model="address_company.street"
                                                                :rules="[rules.required, rules.min]"
                                                                name="street"
                                                                label="Straße + Hausnummer (Geschäftsadresse) *"
                                                                hint="oder ggf. Postfachnummer"
                                                                maxlength="60"
                                                                clearable
                                                                autocomplete="address-line1"
                                                                required
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md6 pl-2>
                                                            <v-text-field
                                                                v-model="address_company.additional"
                                                                label="C/O, Adresszusatz"
                                                                maxlength="36"
                                                                clearable
                                                                autocomplete="address-line2"
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md6 pr-2>
                                                            <v-layout justify-center>
                                                                <v-flex xs12 md6 pr-2>
                                                                    <v-text-field
                                                                        type="number"
                                                                        v-model="address_company.zipcode"
                                                                        :rules="[rules.required, rules.zippy]"
                                                                        name="zipcode"
                                                                        label="PLZ *"
                                                                        hint="(Postleitzahl)"
                                                                        min="1000"
                                                                        max="99998"
                                                                        required
                                                                        autocomplete="postal-code"
                                                                    />
                                                                </v-flex>
                                                                <v-flex xs12 md6 pl-2>
                                                                    <v-text-field
                                                                        v-model="address_company.city"
                                                                        :rules="[rules.required]"
                                                                        name="city"
                                                                        label="Ort *"
                                                                        hint="Ort oder Stadt der PLZ"
                                                                        maxlength="60"
                                                                        clearable
                                                                        autocomplete="address-level1"
                                                                        required
                                                                    />
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 md6 pl-2>
                                                            <v-autocomplete
                                                                :items="countryoptions"
                                                                v-model="address_company.countrycode"
                                                                name="countrycode"
                                                                open-on-clear
                                                                label="Land"
                                                                maxlength="2"
                                                                clearable
                                                                autocomplete="country"
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-card-actions class="pa-0">
                                                        <v-btn flat color="secondary" @click="show_form_companyaddress = false">Abbrechen</v-btn>
                                                        <v-spacer />
                                                        <v-btn color="black" dark @click="submit('form_companyaddress')">Speichern</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-card>
                                        </v-bottom-sheet>
                                    </template>
                                </v-input>
                                <v-divider class="my-2"></v-divider>
                            </v-flex>

                            <v-flex id="Postanschrift" xs12>
                                <small>Postanschrift</small>
                                <v-input messages="Falls abweichend von Geschäftsadresse" append-icon="edit" prepend-icon="place">
                                    <span v-html="address_post.street ? `${address_post.street ? address_post.street : ''}${address_post.additional ? '<br/>'+address_post.additional : ''}<br/>${address_post.zipcode ? address_post.zipcode : ''} ${address_post.city ? address_post.city : ''}<br/>${getCountryFromCountrycode(address_post.countrycode)}` : ``"></span>
                                    <template slot="append">
                                        <v-bottom-sheet v-model="show_form_postaddress" lazy inset>
                                            <template v-slot:activator>
                                                <v-btn icon>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card class="pa-3" tile>
                                                <v-form ref="form_postaddress" lazy-validation @submit.prevent="submit('form_postaddress')">
                                                    <v-layout row wrap justify-center>
                                                        <v-flex xs12 md6 pr-2>
                                                            <v-text-field
                                                                v-model="address_post.street"
                                                                name="street"
                                                                label="Straße + Hausnummer (Postanschrift)"
                                                                hint="oder ggf. Postfachnummer"
                                                                maxlength="60"
                                                                clearable
                                                                autocomplete="address-line1"
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md6 pl-2>
                                                            <v-text-field
                                                                v-model="address_post.additional"
                                                                label="C/O, Adresszusatz"
                                                                maxlength="36"
                                                                clearable
                                                                autocomplete="address-line2"
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md6 pr-2>
                                                            <v-layout justify-center>
                                                                <v-flex xs12 md6 pr-2>
                                                                    <v-text-field
                                                                        type="number"
                                                                        v-model="address_post.zipcode"
                                                                        :rules="[rules.zippy]"
                                                                        name="zipcode"
                                                                        label="PLZ"
                                                                        hint="(Postleitzahl)"
                                                                        min="1000"
                                                                        max="99998"
                                                                        autocomplete="postal-code"
                                                                    />
                                                                </v-flex>
                                                                <v-flex xs12 md6 pl-2>
                                                                    <v-text-field
                                                                        v-model="address_post.city"
                                                                        name="city"
                                                                        label="Ort"
                                                                        hint="Ort oder Stadt der PLZ"
                                                                        maxlength="60"
                                                                        clearable
                                                                        autocomplete="address-level1"
                                                                    />
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 md6 pl-2>
                                                            <v-autocomplete
                                                                :items="countryoptions"
                                                                v-model="address_post.countrycode"
                                                                name="countrycode"
                                                                open-on-clear
                                                                label="Land"
                                                                maxlength="2"
                                                                clearable
                                                                autocomplete="country"
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-card-actions class="pa-0">
                                                        <v-btn flat color="secondary" @click="show_form_postaddress = false">Abbrechen</v-btn>
                                                        <v-spacer />
                                                        <v-btn color="black" dark @click="submit('form_postaddress')">Speichern</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-card>
                                        </v-bottom-sheet>
                                    </template>
                                </v-input>
                                <v-divider class="my-2"></v-divider>
                            </v-flex>

                            <v-flex id="Privatadresse" xs12>
                                <small>Privatadresse</small>
                                <v-input messages="Ihre private Anschrift" append-icon="edit" prepend-icon="person_pin_circle">
                                    <span v-html="address_private.street ? `${address_private.street ? address_private.street : ''}${address_private.additional ? '<br/>'+address_private.additional : ''}<br/>${address_private.zipcode ? address_private.zipcode : ''} ${address_private.city ? address_private.city : ''}<br/>${getCountryFromCountrycode(address_private.countrycode)}` : ``"></span>
                                    <template slot="append">
                                        <v-bottom-sheet v-model="show_form_privateaddress" inset>
                                            <template v-slot:activator>
                                                <v-btn icon>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card class="pa-3" tile>
                                                <v-form ref="form_privateaddress" lazy-validation @submit.prevent="submit('form_privateaddress')">
                                                    <v-layout row wrap justify-center>
                                                        <v-flex xs12 md6 pr-2>
                                                            <v-text-field
                                                                v-model="address_private.street"
                                                                name="street"
                                                                label="Straße + Hausnummer (Privatadresse)"
                                                                hint="oder ggf. Postfachnummer"
                                                                maxlength="60"
                                                                clearable
                                                                autocomplete="address-line1"
                                                            >
                                                                <template v-slot:append-outer>
                                                                    <v-tooltip left>
                                                                        <template v-slot:activator="{ on }">
                                                                            <v-icon v-on="on" @click="copyPostalAddress('address_private')">wrap_text</v-icon>
                                                                        </template>
                                                                        Postanschrift übernehmen
                                                                    </v-tooltip>
                                                                </template>
                                                            </v-text-field>
                                                        </v-flex>
                                                        <v-flex xs12 md6 pl-2>
                                                            <v-text-field
                                                                v-model="address_private.additional"
                                                                label="C/O, Adresszusatz"
                                                                maxlength="36"
                                                                clearable
                                                                autocomplete="address-line2"
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md6 pr-2>
                                                            <v-layout justify-center>
                                                                <v-flex xs12 md6 pr-2>
                                                                    <v-text-field
                                                                        type="number"
                                                                        v-model="address_private.zipcode"
                                                                        name="zipcode"
                                                                        label="PLZ"
                                                                        hint="(Postleitzahl)"
                                                                        min="1000"
                                                                        max="99998"
                                                                        autocomplete="postal-code"
                                                                    />
                                                                </v-flex>
                                                                <v-flex xs12 md6 pl-2>
                                                                    <v-text-field
                                                                        v-model="address_private.city"
                                                                        name="city"
                                                                        label="Ort"
                                                                        hint="Ort oder Stadt der PLZ"
                                                                        maxlength="60"
                                                                        clearable
                                                                        autocomplete="address-level1"
                                                                    />
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 md6 pl-2>
                                                            <v-autocomplete
                                                                :items="countryoptions"
                                                                v-model="address_private.countrycode"
                                                                name="countrycode"
                                                                open-on-clear
                                                                label="Land"
                                                                maxlength="2"
                                                                clearable
                                                                autocomplete="country"
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-card-actions class="pa-0">
                                                        <v-btn flat color="secondary" @click="show_form_privateaddress = false">Abbrechen</v-btn>
                                                        <v-spacer />
                                                        <v-btn color="black" dark @click="submit('form_privateaddress')">Speichern</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-card>
                                        </v-bottom-sheet>
                                    </template>
                                </v-input>
                                <v-divider class="my-2"></v-divider>
                            </v-flex>

                            <v-flex v-for="(riskaddress, index) in addresses_risk" :key="riskaddress.id" xs12 pb-3>
                                <small>Risikoanschrift {{ Number(index)+1 }}</small>
                                <v-input messages="Die zu versichernde Adresse/ die zuversichernde Niederlassung, des Unternehmens" append-icon="edit" prepend-icon="add_location">
                                    <span v-html="riskaddress.street ? `${riskaddress.street}${riskaddress.additional ? '<br/>'+riskaddress.additional : ''}<br/>${riskaddress.zipcode ? riskaddress.zipcode : ''} ${riskaddress.city ? riskaddress.city : ''}<br/>${getCountryFromCountrycode(riskaddress.countrycode)}` : ``"></span>
                                    <template slot="append">
                                        <v-btn icon @click="getRiskAdressBottomsheet(index)">
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                    </template>
                                </v-input>
                            </v-flex>
                        </v-layout>
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                    <v-btn absolute dark fab bottom right color="black" v-on="on" @click="getRiskAdressBottomsheet"><v-icon>add</v-icon></v-btn>
                            </template>
                            <span>Risikoadresse hinzufügen</span>
                        </v-tooltip>
                    </v-card-text>
                </v-card>
            </v-flex>


            <v-flex xs12 lg8 offset-lg2>
                <v-card class="mt-4">
                    <v-card-title class="pb-1">
                        <h3 class="headline mb-0">Weitere Inhaber / Angestellte / Familienmitglieder</h3>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap justify-center>
                            <v-flex v-for="(person, index) in persons" :key="index" xs12 pb-3>
                                <v-input>
                                    <template slot="prepend">
                                        <v-icon>{{relationships[person.relationship].icon}}</v-icon>
                                    </template>
                                    <span v-html="`<small>${relationships[person.relationship].title}</small><br/>${person.salutation} ${person.forename} ${person.surname}`"></span>
                                    <template slot="append">
                                        <v-btn icon @click="getPersonBottomsheet(index)">
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                    </template>
                                </v-input>
                            </v-flex>
                        </v-layout>
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                    <v-btn absolute dark fab bottom right color="black" v-on="on" @click="getPersonBottomsheet"><v-icon>add</v-icon></v-btn>
                            </template>
                            <span>Person hinzufügen</span>
                        </v-tooltip>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

        <v-dialog v-model="bankdatachange_dialog" absolute max-width="600">
            <v-card>
                <v-card-title class="headline">
                    <v-icon left>account_balance</v-icon>
                    <span>Neue {{ bankdatachange_accounttype=='company' ? 'geschäftliche' : 'private' }} Bank&shy;verbindung mitteilen</span>
                </v-card-title>
                <v-card-text v-if="contracts4bankaccount.length > 0">
                    <p>Wählen Sie bitte die Verträge aus, welche ab sofort vom Konto {{ bankdatachange_bankdata.iban }} abbuchen sollen:</p>
                    <v-layout row wrap class="contract-overview-box">
                        <v-flex 
                            v-for="item in contracts4bankaccount" 
                            :key="item.id" 
                            :class="`xs12 ${item.status=='Gekündigt' || item.status=='Angebot abgelehnt' || item.status=='Angebot angefragt' || item.status=='Angebot angefragt (VR)' || item.status=='Vertrag abgelaufen' || item.person_type=='dritte' ? 'opa50' : ''}`"
                        >
                            <v-card :title="getContractTitle4Bankaccount(item)" :hover="item.person_type!='dritte'" ripple :disabled="item.person_type=='dritte'" @click="item.person_type!='dritte' ? bankdatachange_values = _.xor(bankdatachange_values, [item.id]) : ''">
                                <v-layout>
                                    <v-flex xs12 sm3>
                                        <v-avatar size="75px" :title="item.productpartner.name">
                                            <img v-if="item.productpartner.logo_url" :src="item.productpartner.logo_url" :alt="item.productpartner.name" class="img-fluid" />
                                            <v-icon v-else>{{ item.product.icon }}</v-icon>
                                        </v-avatar>
                                    </v-flex>
                                    <v-flex xs12 sm8>
                                        <v-card-title primary-title>
                                            <div class="w-100">
                                                <h3 class="headline">{{ item.kind }}</h3>
                                                <div class="status" :class="`${item.color}--text`">{{ item.status ? item.status : 'Vertrag' }}</div>
                                                <div class="money">{{ item.beitrag | toCurrency }} {{ item.beitrag_intervall_name }}</div>
                                            </div>
                                        </v-card-title>
                                    </v-flex>
                                    <v-flex xs12 sm1>
                                        <v-switch v-model="bankdatachange_values" :readonly="true" color="white" :label="bankdatachange_values.includes(item.id) ? `Lastschrift erteilt` : `per Rechnung`" :value="item.id"></v-switch>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-text v-else>
                    <p>Sie haben aktuell keine {{ bankdatachange_accounttype=='company' ? 'geschäftlichen' : 'privaten' }} Verträge hinterlegt.</p>
                    <v-layout row>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn to="/contract/add/" flat class="py-2 fcred--text"><v-icon color="primary" left>add</v-icon> Versicherung hinzufügen</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn flat @click="bankdatachange_dialog = false">Abbrechen</v-btn>
                    <v-spacer />
                    <v-btn v-if="bankdatachange_values.length>0" color="black" dark @click="submitSEPAchanges()" :loading="bankdatachange_loader">Senden</v-btn>
                    <v-btn v-else color="black" dark @click="bankdatachange_dialog = false">Schließen</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-bottom-sheet v-model="show_form_riskaddress" lazy inset>
            <v-card class="pa-3" tile>
                <v-form ref="form_riskaddress" lazy-validation @submit.prevent="setRiskAdress">
                    <v-layout row wrap justify-center>
                        <v-flex xs12 md6 pr-2>
                            <v-text-field
                                v-model="actuall_edit_riskaddress.street"
                                :rules="[rules.required, rules.min]"
                                name="street"
                                label="Straße + Hausnummer (Risikoanschrift) *"
                                hint="oder ggf. Postfachnummer"
                                maxlength="60"
                                clearable
                                required
                            >
                                <template v-slot:append-outer>
                                    <v-tooltip left>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" @click="copyPostalAddress('actuall_edit_riskaddress')">wrap_text</v-icon>
                                        </template>
                                        Postanschrift übernehmen
                                    </v-tooltip>
                                </template>
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 pl-2>
                            <v-text-field
                                v-model="actuall_edit_riskaddress.additional"
                                label="C/O, Adresszusatz"
                                maxlength="36"
                                clearable
                            />
                        </v-flex>
                        <v-flex xs12 md6 pr-2>
                            <v-layout justify-center>
                                <v-flex xs12 md6 pr-2>
                                    <v-text-field
                                        type="number"
                                        v-model="actuall_edit_riskaddress.zipcode"
                                        :rules="[rules.required, rules.zippy]"
                                        name="zipcode"
                                        label="PLZ *"
                                        hint="(Postleitzahl)"
                                        min="1000"
                                        max="99998"
                                        required
                                    />
                                </v-flex>
                                <v-flex xs12 md6 pl-2>
                                    <v-text-field
                                        v-model="actuall_edit_riskaddress.city"
                                        :rules="[rules.required]"
                                        name="city"
                                        label="Ort *"
                                        hint="Ort oder Stadt der PLZ"
                                        maxlength="60"
                                        clearable
                                        required
                                    />
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 md6 pl-2>
                            <v-autocomplete
                                :items="countryoptions"
                                v-model="actuall_edit_riskaddress.countrycode"
                                name="countrycode"
                                open-on-clear
                                label="Land"
                                maxlength="2"
                                clearable
                            />
                        </v-flex>
                    </v-layout>
                    <v-card-actions class="pa-0">
                        <v-btn flat color="secondary" @click="show_form_riskaddress = false">Abbrechen</v-btn>
                        <v-btn :ripple="{ class: 'red--text' }" flat @click="removeAddress(actuall_edit_riskaddress.index)">Löschen</v-btn>
                        <v-spacer />
                        <v-btn color="black" dark @click="setRiskAdress">{{ actuall_edit_riskaddress_btn_txt }}</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-bottom-sheet>

        <v-bottom-sheet v-model="show_form_person" lazy inset>
            <v-card class="pa-3" tile>
                <v-form ref="form_person">
                    <v-layout row wrap justify-center>
                        <v-flex xs12 md6 lg2 pr-2>
                            <v-autocomplete 
                                ref="actuall_edit_person.salutation" 
                                :items="['Herr', 'Frau', 'Divers']" 
                                v-model="actuall_edit_person.salutation" 
                                name="salutation" 
                                open-on-clear 
                                label="Anrede"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg4 pr-2>
                            <v-text-field
                                ref="actuall_edit_person.forename"
                                v-model="actuall_edit_person.forename"
                                maxlength="20"
                                label="Vorname"
                                @keydown.enter="setPerson"
                                clearable
                                autocomplete="given-name"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg4 px-2>
                            <v-text-field
                                ref="actuall_edit_person.surname"
                                v-model="actuall_edit_person.surname"
                                maxlength="36"
                                :rules="[rules.required]"
                                label="Nachname *"
                                @keydown.enter="setPerson"
                                clearable
                                autocomplete="family-name"
                                required
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg2 pl-2>
                            <v-autocomplete 
                                ref="actuall_edit_person.relationship" 
                                :items="getRelationShipArray" 
                                item-text="title"
                                item-value="key"
                                v-model="actuall_edit_person.relationship" 
                                name="relationship" 
                                open-on-clear 
                                label="Beziehung"
                                autocomplete="organization-title"
                            />
                        </v-flex>
                    </v-layout>
                    <v-card-actions class="pa-0">
                        <v-btn flat color="secondary" @click="show_form_person = false">Abbrechen</v-btn>
                        <v-btn :ripple="{ class: 'red--text' }" flat @click="removePerson">Löschen</v-btn>
                        <v-spacer />
                        <v-btn color="black" dark @click="setPerson">{{ actuall_edit_person_btn_txt }}</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-bottom-sheet>

    </v-container>
</template>



<script>
import firebase from 'firebase/app';
import 'firebase/analytics';
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { COUNTRY_OPTIONS } from '@/constants.js'
import ContractList from '@/components/ContractList'

export default {
    data: () => ({
        address_company: {},
        address_post: {},
        address_private: {},
        addresses_risk: [],
        maxloader: 1,
        banks: {
            private: {},
            company: {}
        },
        legalforms: [
            { text: 'Einzelunternehmen', val: 'Einzelunternehmen' },
            { text: 'e.K. - Eingetragener Kaufmann', val: 'e.K.' },
            { text: 'Freiberufler', val: 'Freiberufler' },
            { text: 'e.V. - Eingetragener Verein', val: 'e.V.' },
            { text: 'GbR - Gesellschaft bürgerlichen Rechts', val: 'GbR' },
            { text: 'UG (haftungsbeschränkt) - Unternehmergesellschaft', val: 'UG (haftungsbeschränkt)' },
            { text: 'GmbH - Gesellschaft mit beschränkter Haftung', val: 'GmbH' },
            { text: 'OHG - Offene Handelsgesellschaft', val: 'OHG' },
            { text: 'KG - Kommanditgesellschaft', val: 'KG' },
            { text: 'AG - Aktiengesellschaft', val: 'AG' },
            { text: 'SE - Europäische Gesellschaft', val: 'SE' },
            { text: 'Reisegewerbe', val: 'Reisegewerbe' },
            { text: 'PartG - Partnergesellschaft', val: 'PartG' },
            { text: 'PartGmbB - Partnerschaftsgesellschaft mit beschränkter Berufshaftung', val: 'PartGmbB' },
            { text: 'gGmbH - gemeinnützige GmbH', val: 'gGmbH' },
            { text: 'GmbH & Co. KG - GmbH mit Kommanditgesellschaft', val: 'GmbH & Co. KG' },
            { text: 'UG & Co. KG - Unternehmergesellschaft mit Kommanditgesellschaft', val: 'UG & Co. KG' },
            { text: 'Sonstige', val: '' }
        ],
        relationships: {
            FA: {
                key: 'FA',
                title: 'Familienmitglied',
                icon: 'accessibility_new',
                desc: ''
            },
            GF: {
                key: 'GF',
                title: 'Geschäftsführer',
                icon: 'supervisor_account',
                desc: ''
            },
            VZ: {
                key: 'VZ',
                title: 'Vollzeit-Angestellte',
                icon: 'person',
                desc: ''
            },
            AP: {
                key: 'AP',
                title: 'Ansprechpartner',
                icon: 'person',
                desc: ''
            },
            TZ: {
                key: 'TZ',
                title: 'Teilzeit-Angestellter',
                icon: 'person_outline',
                desc: ''
            },
            MJ: {
                key: 'MJ',
                title: 'Minijobber',
                icon: 'person_pin',
                desc: ''
            },
            ST: {
                key: 'ST',
                title: 'Studentische Hilftskräfte',
                icon: 'school',
                desc: ''
            },
            PR: {
                key: 'PR',
                title: 'Praktikanten',
                icon: 'school',
                desc: ''
            },
            FL: {
                key: 'FL',
                title: 'Freelancer',
                icon: 'transfer_within_a_station',
                desc: ''
            }
        },
        valid: true,
        rules: {
            required: v => !!v || 'Pflichtfeld - Bitte ausfüllen',
            min: v => { 
                if(v){ 
                if(v.length < 6){ 
                    return 'Geben Sie mindestens 6 Zeichen ein'; 
                }else{ 
                    return true;
                }
                }else{
                return true;
                }
            },
            zippy: v => {
                return (v >= 1000 && v <= 99998) || 'Die PLZ muss gültig sein'
            },
            email: v => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(v) || 'Bitte eine gültige E-Mail-Adresse eingeben'
            },
            iban: v => {
                const pattern = /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}$/
                return pattern.test(v) || 'Bitte eine gültige IBAN ohne Sonderzeichen eingeben'
            },
            adult: function(v){
                //bday = this.$moment(v);
                //console.log('test: ', bla, this.$moment().diff(bday, 'years'));
                if(v){
                    var utc = new Date().toJSON().slice(0,10).replace(/-/g,'');
                    let test = v.replace(/-/g,'');
                    //console.log('v: ', v, test, parseInt(test), utc);
                    if(parseInt(test) > (parseInt(utc) - 180000)){
                        return 'Sie müssen mindestens 18 Jahre alt sein'
                    }
                }
                return true;
            },
        },
        user_initstate: null,
        show_form_name: false,
        show_form_tel: false,
        show_form_bday: false,
        show_form_company: false,
        show_form_business: false,
        show_form_founding: false,
        show_form_privatebank: false,
        show_form_companybank: false,
        show_form_postaddress: false,
        show_form_privateaddress: false,
        show_form_riskaddress: false,
        show_form_person: false,
        show_form_companyaddress: false,
        actuall_edit_riskaddress: {},
        actuall_edit_riskaddress_btn_txt: 'Speichern',
        actuall_edit_person: {},
        actuall_edit_person_btn_txt: 'Speichern',
        bankdatachange_dialog: false,
        bankdatachange_loader: false,
        bankdatachange_bankdata: {},
        bankdatachange_values: [],
        bankdatachange_accounttype: 'company'
    }),


    components: {
        ContractList
    },


    created(){
        this.user_initstate = this.getCopyOfUser;
        this.initAddressGetter();
        this.banks = {...this.$store.getters['banks/getBanksBanks']};
        if(!this.banks.company.iban){
            this.$store.dispatch('banks/loadBanks').then(res => {
                this.banks = {...this.$store.getters['banks/getBanksBanks']};
            });
        }
    },


    computed: {
        ...mapState({
            checkoutStatus: state => state.user
        }),
        ...mapGetters('user', {
            user: 'getUserData'
        }),
        ...mapGetters('persons', {
            persons: 'getAllPersons'
        }),
        getCopyOfUser(){
            return {...this.user}
        },
        getRelationShipArray(){
            return _.values(this.relationships);
        },
        countryoptions(){
            return COUNTRY_OPTIONS;
        },
        contracts4bankaccount(){
            return this.$store.getters['contracts/getAllContracts'].filter(o => o.type==this.bankdatachange_accounttype);
        }
    },


    watch: {
        show_form_name: function(){
            if(!this.show_form_name){
                this.user.salutation = this.user_initstate.salutation;
                this.user.forename = this.user_initstate.forename;
                this.user.surname = this.user_initstate.surname;
            }
        },
        show_form_tel: function(){
            if(!this.show_form_tel){
                this.user.fon = this.user_initstate.fon;
            }
        },
        show_form_bday: function(){
            if(!this.show_form_bday){
                this.user.birthday_date = this.user_initstate.birthday_date;
            }
        },
        show_form_company: function(){
            if(!this.show_form_company){
                this.user.company = this.user_initstate.company;
                this.user.legal = this.user_initstate.legal;
            }
        },
        show_form_business: function(){
            if(!this.show_form_business){
                this.user.business = this.user_initstate.business;
            }
        },
        show_form_founding: function(){
            if(!this.show_form_founding){
                this.user.founding_date = this.user_initstate.founding_date;
            }
        },
        show_form_privatebank: function(){
            if(!this.show_form_privatebank){
                this.banks.private = {...this.$store.getters['banks/getBanksByType']('private')};
            }
        },
        show_form_companybank: function(){
            if(!this.show_form_companybank){
                this.banks.company = {...this.$store.getters['banks/getBanksByType']('company')};
                // console.log('this.banks.company :>> ', this.banks.company, {...this.$store.getters['banks/getBanksByType']('company')});
            }
        },
        show_form_postaddress: function(){
            if(!this.show_form_postaddress){
                this.address_post = this.getAddressClone('post');
            }
        },
        show_form_privateaddress: function(){
            if(!this.show_form_privateaddress){
                this.address_private = this.getAddressClone('private');
            }
        },
        show_form_companyaddress: function(){
            if(!this.show_form_companyaddress){
                this.address_company = this.getAddressClone();
            }
        },
    },


  methods: {
        getContractTitle4Bankaccount(contract){
            let title = `${contract.kind ? contract.kind : 'Vertrag'} ${contract.productpartner.name ? 'von: '+contract.productpartner.name : ''}`;
            if(contract.status=='Gekündigt' || contract.status=='Angebot abgelehnt' || contract.status=='Angebot angefragt' || contract.status=='Angebot angefragt (VR)' || contract.status=='Vertrag abgelaufen'){
                 title = `Der Status des Vertrages lässt keine Auswahl aktuell zu.`;
            }
            if(contract.person_type=='dritte'){
                 title = `Verträge, abgeschlossen für Dritte, können hier nicht beachtet werden.`;
            }
            if(contract.bestand=='Fremd'){
                 title = `Die Verwaltung ist erst möglich, wenn der Vertrag vom Versicherer an uns freigegeben wurde. Falls noch nicht erfolgt, unterschreiben Sie dazu bitte den kostenfreien Maklervertrag digital.`;
            }
            return title;
        },

        getCountryFromCountrycode(countrycode){
            if(_.isEmpty(countrycode)){
                return '';
            }
            let tmp = this.countryoptions.find(c => {return c.value == countrycode.toUpperCase()});
            if(!tmp){
                return '';
            }
            return tmp.text;
        },

        initAddressGetter(){
            this.address_company = this.getAddressClone();
            // console.log('this.address_company :>> ', this.address_company, _.isEmpty(this.address_company));
            if(_.isEmpty(this.address_company.street) && _.isEmpty(this.address_post.street) && _.isEmpty(this.address_private.street) && this.maxloader<3){
                this.maxloader++;
                setTimeout(() => { this.initAddressGetter(); }, 2500);
            }
            this.address_post = this.getAddressClone('post');
            this.address_private = this.getAddressClone('private');
            this.addresses_risk = this.getAddressClone('risk');
        },

        getAddressClone(type = 'company'){
            let results = this.$store.getters['addresses/getAddressesByType'](type);
            if(type=='risk'){
                return results.slice(0);  // clone array
            }else{
                if(results.length<1){
                    return { street: '', additional: '', zipcode: '', city: '', countrycode: 'DE', type };
                }
                return {...results[0]};
            }
        },

        copyPostalAddress(formname){
            let copy = {...this.address_post};
            delete copy.id;
            if(this[formname].id){
                copy.id = this[formname].id;
            }
            if(formname == 'actuall_edit_riskaddress'){
                copy.index = this.addresses_risk.length;
            }
            this[formname] = copy;
        },
    
        getRiskAdressBottomsheet(riskaddress_index){
            this.actuall_edit_riskaddress.index = riskaddress_index;
            if(this.addresses_risk[riskaddress_index]){
                this.actuall_edit_riskaddress_btn_txt = 'Speichern';
                this.actuall_edit_riskaddress = this.addresses_risk[riskaddress_index];
            }else{
                this.actuall_edit_riskaddress_btn_txt = 'Hinzufügen';
                this.actuall_edit_riskaddress = { street: '', additional: '', zipcode: '', city: '', countrycode: 'DE', type: 'risk' };
            }
            this.show_form_riskaddress = true;
        },

        removeAddress(riskaddress_index){
            this.$snotify.success('Risikoadresse entfernt');
            this.$store.dispatch('addresses/deleteAddress',this.actuall_edit_riskaddress);
            this.$store.dispatch('chat/addUserChatMessage', {title:'Einstellungen geändert', content:`Diese Risikoadresse wurde entfernt: "${this.actuall_edit_riskaddress.street}, ${this.actuall_edit_riskaddress.additional}, ${this.actuall_edit_riskaddress.zipcode} ${this.actuall_edit_riskaddress.city}, ${this.actuall_edit_riskaddress.countrycode}".`, type: 'settings'});
            this.addresses_risk.splice(riskaddress_index, 1);
            this.show_form_riskaddress = false;
            // this.user_initstate = this.getCopyOfUser;
        },

        setRiskAdress(){
            let index = this.actuall_edit_riskaddress.index;
            delete this.actuall_edit_riskaddress.index;
            if(_.isEmpty(this.actuall_edit_riskaddress.id)){
                this.$snotify.success('Risikoadresse hinzugefügt');
                this.$store.dispatch('addresses/addAddress', this.actuall_edit_riskaddress).then(id => {
                    this.actuall_edit_riskaddress.id = id;
                    this.addresses_risk.push(this.actuall_edit_riskaddress);
                });
                let chatcon = `Eine neue Risikoadresse wurde hinzugefügt: "${this.actuall_edit_riskaddress.street}, ${this.actuall_edit_riskaddress.additional}, ${this.actuall_edit_riskaddress.zipcode} ${this.actuall_edit_riskaddress.city}, ${this.actuall_edit_riskaddress.countrycode}".`;
                this.$store.dispatch('chat/addUserChatMessage', {
                    title: 'Einstellungen geändert', 
                    content: chatcon, 
                    type: 'settings'
                });
                this.$store.dispatch('chat/setTodo', {
                    type: `NEW_RISKADDRESS`,
                    subject: `Neue Risikoadresse hinzugefügt`,
                    content: chatcon,
                    add_data: JSON.stringify(this.actuall_edit_riskaddress)
                });
            }else{
                this.$snotify.success('Risikoadresse verändert');
                this.$store.dispatch('addresses/setAddress', this.actuall_edit_riskaddress);
                this.$store.dispatch('chat/addUserChatMessage', {title:'Einstellungen geändert', content:`Die Risikoadresse wurde geändert in: "${this.actuall_edit_riskaddress.street}, ${this.actuall_edit_riskaddress.additional}, ${this.actuall_edit_riskaddress.zipcode} ${this.actuall_edit_riskaddress.city}, ${this.actuall_edit_riskaddress.countrycode}".`, type: 'settings'});
                this.addresses_risk[index] = this.actuall_edit_riskaddress;
            }
            this.show_form_riskaddress = false;
        },

        getCensoredIban(iban){
            if(iban){
                return _.padStart(_.trim(iban).substr(iban.length - 4), iban.length, 'X');
            }else{
                return '';
            }
        },

        getPersonBottomsheet(person_index){
            //console.log('person_index: ', person_index, this.persons[person_index]);
            if(this.persons[person_index]){
                this.actuall_edit_person_btn_txt = 'Speichern';
                this.actuall_edit_person = this.persons[person_index];
                this.actuall_edit_riskaddress.new = false;
            }else{
                this.actuall_edit_person_btn_txt = 'Hinzufügen';
                this.actuall_edit_person = { new: true, salutation: '', forename: '', surname: '', relationship: 'VZ' };
            }
            this.show_form_person = true;
        },
        
        removePerson(){
            this.$snotify.success('Person erfolgreich gelöscht');
            this.$store.dispatch('persons/deletePerson',this.actuall_edit_person);
            this.$store.dispatch('chat/addUserChatMessage', {title:'Einstellungen geändert', content:`Die Person "${this.actuall_edit_person.salutation} ${this.actuall_edit_person.forename} ${this.actuall_edit_person.surname}" wurde entfernt.`, type: 'settings'});
            this.show_form_person = false;
        },

        setPerson(){
            if(this.actuall_edit_person.new){
                delete this.actuall_edit_person.new;
                this.$snotify.success('Person hinzugefügt');
                this.$store.dispatch('persons/addPerson', this.actuall_edit_person);
                this.$store.dispatch('chat/addUserChatMessage', {title:'Einstellungen geändert', content:`Die Person "${this.actuall_edit_person.salutation} ${this.actuall_edit_person.forename} ${this.actuall_edit_person.surname}" wurde neu hinzugefügt.`, type: 'settings'});
            }else{
                delete this.actuall_edit_person.new;
                this.$snotify.success('Person bearbeitet');
                this.$store.dispatch('persons/setPerson', this.actuall_edit_person);
                this.$store.dispatch('chat/addUserChatMessage', {title:'Einstellungen geändert', content:`Die Person wurde von "${this.actuall_edit_person.salutation} ${this.actuall_edit_person.forename} ${this.actuall_edit_person.surname}" in "${this.actuall_edit_person.salutation} ${this.actuall_edit_person.forename} ${this.actuall_edit_person.surname}" umgeändert.`, type: 'settings'});
            }
            this.show_form_addedit = false;
            this.show_form_person = false;
        },

        submit(formkey) {
            // console.log('form_founding :>> ', formkey, this.$refs[formkey].validate());
            if (!this.$refs[formkey].validate()) {
                this.$snotify.error('Bitte überprüfen Sie Ihre Eingaben');
            }else{
                if(this.user_initstate!=this.user){
                    let con = 'Eine Profileinstellung wurde verändert.';
                    let init = null;
                    switch (formkey) {
                        case 'form_name':
                            con = `Der Name wurde von "${this.user_initstate.salutation ? this.user_initstate.salutation : ''} ${this.user_initstate.title ? this.user_initstate.title : ''} ${this.user_initstate.forename ? this.user_initstate.forename : ''} ${this.user_initstate.surname ? this.user_initstate.surname : ''}" in "${this.user.salutation} ${this.user.title} ${this.user.forename} ${this.user.surname}" umgeändert.`;
                        break;
                        case 'form_tel':
                            con = `Die Telefonnummer wurde von "${this.user_initstate.fon ? this.user_initstate.fon : ''}" in "${this.user.fon}" umgeändert.`;
                        break;
                        case 'form_bday':
                            con = `Der Geburstag wurde von "${this.user_initstate.birthday_date ? moment(this.user_initstate.birthday_date).format('DD.MM.YYYY').toString() : ''}" in "${moment(this.user.birthday_date).format('DD.MM.YYYY').toString()}" umgeändert.`;
                        break;
                        case 'form_company':
                            con = `Der Unternehmensname wurde von "${this.user_initstate.company ? this.user_initstate.company : ''} ${this.user_initstate.legal ? this.user_initstate.legal : ''}" in "${this.user.company} ${this.user.legal}" umgeändert.`;
                            if(this.$store.getters['user/getUsersCookieConsent']=='all'){ firebase.analytics().setUserProperties({legal: this.user.legal, company: this.user.company}); };
                        break;
                        case 'form_founding':
                            con = `Das Gründungsdatum wurde von "${this.user_initstate.founding_date ? moment(this.user_initstate.founding_date).format('DD.MM.YYYY').toString() : ''}" in "${moment(this.user.founding_date).format('DD.MM.YYYY').toString()}" umgeändert.`;
                        break;
                        case 'form_business':
                            con = `Die unternehmerische Tätigkeit wurde von "${this.user_initstate.business ? this.user_initstate.business : ''}" in "${this.user.business}" umgeändert.`;
                        break;
                        case 'form_privatebank':
                            init = this.$store.getters['banks/getBanksByType']('private');
                            con = `Die persönlichen Bankdaten wurden von "${init.owner_name ? init.owner_name : ''}, ${init.iban ? init.iban : ''}, ${init.bank_name ? init.bank_name : ''}" in "${this.banks.private.owner_name ? this.banks.private.owner_name : ''}, ${this.banks.private.iban ? this.banks.private.iban : ''}, ${this.user.privatebank_name ? this.user.privatebank_name : ''}" umgeändert.`;
                        break;
                        case 'form_companybank':
                            init = this.$store.getters['banks/getBanksByType']('private');
                            con = `Die Unternehmens-Bankdaten wurden von "${init.owner_name ? init.owner_name : ''}, ${init.iban ? init.iban : ''}, ${init.bank_name ? init.bank_name : ''}" in "${this.banks.company.owner_name ? this.banks.company.owner_name : ''}, ${this.banks.company.iban ? this.banks.company.iban : ''}, ${this.banks.company.bank_name ? this.banks.company.bank_name : ''}" umgeändert.`;
                        break;
                        case 'form_postaddress':
                            if(_.isEmpty(this.address_post.countrycode)){ this.address_post.countrycode = 'DE'; };
                            init = this.getAddressClone('post');
                            con = `Die Postadresse wurde von "${init.street ? init.street : ''}, ${init.additional ? init.additional : ''}, ${init.zipcode ? init.zipcode : ''} ${init.city ? init.city : ''}, ${init.countrycode ? init.countrycode : ''}" in "${this.address_post.street ? this.address_post.street : ''}, ${this.address_post.additional ? this.address_post.additional : ''}, ${this.address_post.zipcode ? this.address_post.zipcode : ''} ${this.address_post.city ? this.address_post.city : ''}, ${this.address_post.countrycode ? this.address_post.countrycode : ''}" umgeändert.`;
                        break;
                        case 'form_privateaddress':
                            if(_.isEmpty(this.address_private.countrycode)){ this.address_private.countrycode = 'DE'; };
                            init = this.getAddressClone('private');
                            con = `Die Privatadresse wurde von "${init.street ? init.street : ''}, ${init.additional ? init.additional : ''}, ${init.zipcode ? init.zipcode : ''} ${init.city ? init.city : ''}, ${init.countrycode ? init.countrycode : ''}" in "${this.address_private.street ? this.address_private.street : ''}, ${this.address_private.additional ? this.address_private.additional : ''}, ${this.address_private.zipcode ? this.address_private.zipcode : ''} ${this.address_private.city ? this.address_private.city : ''}, ${this.address_private.countrycode ? this.address_private.countrycode : ''}" umgeändert.`;
                        break;
                        case 'form_companyaddress':
                            if(_.isEmpty(this.address_company.countrycode)){ this.address_company.countrycode = 'DE'; };
                            init = this.getAddressClone();
                            con = `Die Geschäftsadresse wurde von "${init.street ? init.street : ''}, ${init.additional ? init.additional : ''}, ${init.zipcode ? init.zipcode : ''} ${init.city ? init.city : ''}, ${init.countrycode ? init.countrycode : ''}" in "${this.address_company.street ? this.address_company.street : ''}, ${this.address_company.additional ? this.address_company.additional : ''}, ${this.address_company.zipcode ? this.address_company.zipcode : ''} ${this.address_company.city ? this.address_company.city : ''}, ${this.address_company.countrycode ? this.address_company.countrycode : ''}" umgeändert.`;
                        break;
                            default:
                        break;
                    }
                    //console.log(con);
                    this.user.updated_date = this.$moment().format('YYYY-MM-DD HH:mm:ss').toString();
                    if(formkey == 'form_companyaddress'){
                        this.$store.dispatch(`addresses/${this.address_company.id ? 'set' : 'add'}Address`, this.address_company);
                        this.$snotify.success('Ihre Versicherungen wurden über die Adressänderung informiert');
                    }else if(formkey == 'form_postaddress'){
                        this.$store.dispatch(`addresses/${this.address_post.id ? 'set' : 'add'}Address`, this.address_post);
                        this.$snotify.success('Ihre Versicherungen wurden über die Adressänderung informiert');
                    }else if(formkey == 'form_privateaddress'){
                        this.$store.dispatch(`addresses/${this.address_private.id ? 'set' : 'add'}Address`, this.address_private);
                        this.$snotify.success('Ihre Versicherungen wurden über die Adressänderung informiert');
                    }else if(formkey == 'form_companybank'){
                        this.banks.company.type = 'company';
                        this.$store.dispatch(`banks/${this.banks.company.id ? 'set' : 'add'}Bank`, this.banks.company).then(id => {
                            this.banks.company.id = id;
                        });
                        this.$snotify.success('Gespeichert');
                    }else if(formkey == 'form_privatebank'){
                        this.banks.private.type = 'private';
                        this.$store.dispatch(`banks/${this.banks.private.id ? 'set' : 'add'}Bank`, this.banks.private).then(id => {
                            this.banks.private.id = id;
                        });
                        this.$snotify.success('Gespeichert');
                    }else{
                        this.$store.dispatch('user/setUserData', this.user);
                        this.$snotify.success('Gespeichert');
                    }
                    this.$store.dispatch('chat/addUserChatMessage', {title:'Einstellungen geändert', content:con, type: 'settings'});
                    if(formkey=='form_company' || formkey=='form_name'){
                        this.$store.dispatch('auth/setDisplayName', this.$store.getters['user/getDisplayName'](false));
                    }
                    if(formkey!='form_founding' && formkey!='form_tel' && formkey!='form_bday'){
                        this.$store.dispatch('chat/setTodo', {
                            type: `EDIT_SETTINGS`,
                            subject: `Kundendatenänderung von ${this.$store.getters['user/getDisplayName']()}`,
                            content: con,
                            add_data: JSON.stringify(this.user_initstate),
                            is_resubmission: (formkey=='form_companyaddress' || formkey=='form_postaddress' || formkey=='form_privateaddress' || formkey=='form_companybank' || formkey=='form_privatebank') ? false : true // wiedervorlage wird im backend geregelt für diese cases
                        });
                    };
                    // eval(`this.show_${formkey} = false`);
                    this[`show_${formkey}`] = false;
                    this.user_initstate = this.getCopyOfUser;
                    // this.show_form_privateaddress = false;
                    // this.show_form_riskaddress = false;
                    // this.show_form_postaddress = false;
                    // this.show_form_companyaddress = false;
                    if((formkey=='form_companybank' || formkey=='form_privatebank') && this.bankdatachange_dialog==false){
                        this.bankdatachange_dialog = true;
                        this.bankdatachange_accounttype = formkey=='form_privatebank' ? 'private' : 'company';
                        this.bankdatachange_bankdata = formkey=='form_privatebank' ? this.banks.private : this.banks.company;
                        this.bankdatachange_values = [];
                        this.contracts4bankaccount.forEach(contract => {
                            if(contract.zahlungsart=='Lastschrift'){
                                this.bankdatachange_values.push(contract.id);
                            }
                        });
                    }
                }
            }
        },

        submitSEPAchanges(){
            this.bankdatachange_loader = true;
            this.$store.dispatch(`banks/sendChangedBankdataReportMail`, { bankdata: this.banks[this.bankdatachange_accounttype], contract2contact: this.bankdatachange_values }).then(response => {
                this.$snotify.success('Ihre Bankverbindung wurde für die ausgewählten Verträge an die entsprechenden Versicherer erfolgreich gesendet.', null, {timeout:6000});
            }).catch(err => {
                console.error('sendChangedBankdataReportMail :>> ', err);
                this.$snotify.error('Ein Fehler ist aufgetreten - bitte einfach via Chat ankündigen - wir kümmern uns um den Rest :)', null, {timeout:6000});
            }).finally(() => {
                this.bankdatachange_loader = false;
                this.bankdatachange_dialog = false;
            })
        }
    }
}
</script>

<style scoped>
    small{
      padding-left: 32px;
    }
    .money{
        font-size: 16px;
    }
    .status{
        padding-block-start: 1rem;
    }
    h3.headline{
        word-break: break-word;
    }
    .v-card__title.headline{
        display: block;
    }
    .opa50 > *{
        cursor: not-allowed;
    }
    .contract-overview-box .v-input--switch{
        height: 100%;
        margin: 0;
        align-items: center;
        position: relative;
    }


    @media screen and (max-width: 768px) {
        .pr-4, .pl-4, .pr-2, .pl-2, .px-2, .px-4{
            padding:0!important;
        }
    }


    @media screen and (max-width: 576px) {
        .v-card .layout{
            flex-direction: column;
        }
        .v-card .layout > .xs0{
            padding-top: 16px;
        }
        .status{
            padding-block-start: 0;
        }
        .contract-overview-box {
            text-align: center;
        }
        .contract-overview-box .v-avatar {
            padding-top: 1rem;
        }
        .contract-overview-box .v-avatar .v-icon {
            font-size: 5rem;
        }
        .contract-overview-box .v-input--switch{
            padding-bottom: .5rem;
            justify-content: center;
        }
        .v-input .v-input__control{
            max-width: calc(100% - 78px);
        }
    }
</style>
